import React, { useState } from 'react';
import Suggest from './Suggest/Suggest.jsx';

const Autocomplete = (props) => {
  const { error, suggestions, ...input } = props;
  const AutocompleteInput = React.createRef();

  let [showSuggestions, setShowSuggestions] = useState(false);
  let [activeSuggestionIndex, setActiveSuggestionIndex] = useState(undefined);

  const setSuggestionValue = (value) => {
    setShowSuggestions(false);
    setActiveSuggestionIndex(undefined);
    input.onChange(value);
    AutocompleteInput.current.focus();
  };

  const handleChange = (event) => {
    input.onChange(event.currentTarget.value);
    setShowSuggestions(true);
  };

  const handleBlur = (event) => {
    input.onBlur(event);
    setShowSuggestions(false);
  };

  const handleSuggestionMouseOver = (activeSuggestionIndex) => setActiveSuggestionIndex(activeSuggestionIndex);
  const handleSuggestionMouseDown = (value) => setSuggestionValue(value);

  const handleKeyDown = (event) => {
    switch (event.key) {
      case 'ArrowDown': {
        let nextActiveSuggestion = activeSuggestionIndex + 1;
        if (activeSuggestionIndex === undefined || nextActiveSuggestion === props.suggestions.length) setActiveSuggestionIndex(0);
        else setActiveSuggestionIndex(nextActiveSuggestion);
        break;
      }
      case 'ArrowUp': {
        let nextActiveSuggestion = activeSuggestionIndex - 1;
        if (activeSuggestionIndex === undefined || nextActiveSuggestion === -1) setActiveSuggestionIndex(props.suggestions.length - 1);
        else setActiveSuggestionIndex(nextActiveSuggestion);
        break;
      }
      case 'Enter':
        if (showSuggestions) {
          event.preventDefault();
          setSuggestionValue(props.suggestions[activeSuggestionIndex]);
        }
        break;
      default:
        return;
    }
  };

  const suggestionsItems = suggestions.map((s, i) => <Suggest key={ i }
                                                              value={ s }
                                                              index={ i }
                                                              active={ activeSuggestionIndex }
                                                              onMouseOver={ handleSuggestionMouseOver }
                                                              onMouseDown={ handleSuggestionMouseDown }/>);

  return <div className="cabinet-autocomplete">
    <input ref={ AutocompleteInput }
           { ...input }
           type="text"
           onChange={ handleChange }
           onBlur={ handleBlur }
           onKeyDown={ handleKeyDown }
           className={ props.className }
           autoFocus={ props.autoFocus }
           autoComplete='off'
           ref={ props.inputRef }/>
    { (!error && showSuggestions) &&
      <div className="cabinet-autocomplete-suggestions">
        { suggestionsItems.length ? suggestionsItems : <span className="small">{ gettext('Ничего не найдено') }</span> }
      </div>
    }
  </div>
};

export default Autocomplete;